import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AppComponent } from 'src/app/app.component';
import { SharkifyAiSerivceService } from 'src/app/sharkify-ai-serivce.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-edit-businessinfo',
  templateUrl: './edit-businessinfo.component.html',
  styleUrls: ['./edit-businessinfo.component.css']
})
export class EditBusinessinfoComponent implements OnInit {
  currentPage = 0;
  BusinessInfo: any;
  BusinessInfos: any;
  BusinessInfoId: any;
  EditBusinessInfos: any;
  selectedValue: string = '';
  stylesValue: string = '';
  scheduleValue: string = '';
  online: string = '';
  UserId: any;
  offline: string = '';
  instagramFollowers: number | null = null;
  fromAge: number | null = null;
  toAge: number | null = null;
  weekValues: string = '';
  genderValues: string = '';
  contentValues: string[] = [];
  goalValues: string[] = [];
  Content_Requirements_Sample_Images: string[] = [];
  Business_Specific_Uploads_Images: string[] = [];
  ContentRequirements_SampleImages : string[] = [];
  BusinessSpecificUploads_Images : string[] = [];
  tags: string[] = [];
  inputValue: string = '';
  onlineSales = new FormControl('');
  offlineFootfall = new FormControl('');
  BusinessInfo_BusinessName = new FormControl('', Validators.required);
  BusinessInfo_BusinessCategory = new FormControl('', Validators.required);
  BusinessInfo_BusinessCode = new FormControl('', Validators.required);
  BusinessInfo_BusinessType = new FormControl('', Validators.required);
  BusinessInfo_WebsiteURL = new FormControl('');
  CurrentOnlinePresence_DoYouCurrentlySellOnline = new FormControl('', Validators.required);
  CurrentOnlinePresence_InstagramFollowers = new FormControl('');
  CurrentOnlinePresence_InstagramUsername = new FormControl('');
  CurrentOnlinePresence_LinkedInUsername = new FormControl('');
  ContentRequirements_IntrestedContent = new FormControl('', Validators.required);
  ContentRequirements_SpecificThemes = new FormControl('', Validators.required);
  ContentRequirements_Description = new FormControl('');
  // ContentRequirements_SampleImages = new FormControl('');
  TargetAudience_FromAge = new FormControl('', Validators.required);
  TargetAudience_ToAge = new FormControl('', Validators.required);
  TargetAudience_Gender = new FormControl('', Validators.required);
  TargetAudience_Interests = new FormControl('', Validators.required);
  TargetAudience_SpecificLocations: string = '';
  ContentGoals_PrimaryGoals = new FormControl('', Validators.required);
  ContentGoals_KeyMessages = new FormControl('');
  RegularPostingSchedule_Customize = new FormControl('', Validators.required);
  RegularPostingSchedule_Mon = new FormControl('');
  RegularPostingSchedule_Tue = new FormControl('');
  RegularPostingSchedule_Wed = new FormControl('');
  RegularPostingSchedule_Thu = new FormControl('');
  RegularPostingSchedule_Fri = new FormControl('');
  RegularPostingSchedule_Sat = new FormControl('');
  RegularPostingSchedule_Sun = new FormControl('');
  // BusinessSpecificUploads_Images = new FormControl('');
  BusinessSpecificUploads_Services = new FormControl('', Validators.required);
  CompetitorInformation_Details = new FormControl('');
  AdditionalDetails_Details = new FormControl('');
  errorMessage: string | null = null;

  validateSchedule() {
    const days = [
      this.RegularPostingSchedule_Mon.value,
      this.RegularPostingSchedule_Tue.value,
      this.RegularPostingSchedule_Wed.value,
      this.RegularPostingSchedule_Thu.value,
      this.RegularPostingSchedule_Fri.value,
      this.RegularPostingSchedule_Sat.value,
      this.RegularPostingSchedule_Sun.value
    ];

    let postCount = 0;
    let reelCount = 0;
    let carouselCount = 0;

    days.forEach((day) => {
      if (day === 'Post') postCount++;
      if (day === 'Reel') reelCount++;
      if (day === 'Carousel') carouselCount++;
    });

    if (postCount > 5) {
      this.errorMessage = 'No more than 5 Posts allowed';
    } else if (reelCount > 1) {
      this.errorMessage = 'No more than 1 Reel allowed';
    } else if (carouselCount > 1) {
      this.errorMessage = 'No more than 1 Carousel allowed';
    } else {
      this.errorMessage = null;
    }
  }
  onScheduleChange() {
    this.validateSchedule();
  }

  onFileSelected(event: any, type: 'BusinessSpecificUploads' | 'ContentRequirements'): void {
    const input: FileList = event.target.files;
    
    if (input && input.length > 0) {
      const Content_Requirements_Sample_Images: string[] = [];
  
      Array.from(input).forEach((file: File) => {
        const reader = new FileReader();
        reader.onload = (e: any) => {
          const imageDataUrl = e.target.result;
          Content_Requirements_Sample_Images.push(imageDataUrl);
          if (type === 'BusinessSpecificUploads') {
            this.BusinessSpecificUploads_Images.push(imageDataUrl);
            this.Business_Specific_Uploads_Images=this.BusinessSpecificUploads_Images;
          } else if (type === 'ContentRequirements') {
            this.ContentRequirements_SampleImages.push(imageDataUrl);
                this.Content_Requirements_Sample_Images= this.ContentRequirements_SampleImages;
            
          }
        };
       
        reader.readAsDataURL(file);
      });
     
      
      
    }
  }
 
  

  // onFileSelected(event: Event): void {
  //   const input = event.target as HTMLInputElement;
  //   if (input.files) {
  //     Array.from(input.files).forEach((file) => {
  //       const reader = new FileReader();
  //       reader.onload = () => {
  //         if (reader.result) {
  //           if (!this.Content_Requirements_Sample_Images.includes(reader.result.toString())) {
  //             this.Content_Requirements_Sample_Images.push(reader.result.toString());
  //           }
  //         }
  //       };
  //       reader.readAsDataURL(file);
  //     });
  //   }
  // }
  deleteImage(index: number, image_data: any) {
    image_data.splice(index, 1); // Remove image from array
  }

  pages = [
    'business_information_content',
    'Current_online_presence_content',
    'Content_Requirements_content',
    'Target_Audience_content',
    'Content_Goals_content',
    'Regular_Posting_Schedule_content',
    'Business_Specific_Uploads_content',
    'Competitor_Information_content',
    'Additional_Details_content'
  ];
  nextPage() {
    if (this.isPageValid(this.currentPage)) {
      if (this.currentPage < this.pages.length - 1) {
        this.currentPage++;
      }
    }
  }
  private isPageValid(pageIndex: number): boolean {
    switch (pageIndex) {
      // case 0:
      //   return this.BusinessInfo_BusinessName.valid &&
      //     this.BusinessInfo_BusinessCategory.valid &&
      //     this.BusinessInfo_BusinessCode.valid &&
      //     this.BusinessInfo_BusinessType.valid;
      // case 1:
      //   return this.CurrentOnlinePresence_DoYouCurrentlySellOnline.valid;
      // case 2:
      //   return this.ContentRequirements_IntrestedContent.valid &&
      //     this.ContentRequirements_SpecificThemes.valid;
      // case 3:
      //   return this.TargetAudience_FromAge.valid &&
      //     this.TargetAudience_ToAge.valid &&
      //     this.TargetAudience_Gender.valid &&
      //     this.TargetAudience_Interests.valid;
      // case 4:
      //   return this.ContentGoals_PrimaryGoals.valid;
      // case 5:
      //   return this.RegularPostingSchedule_Customize.valid;
      // case 6:
      //   return this.BusinessSpecificUploads_Services.valid;
      default:
        return true;
    }
  }

  type = [
    { value: 'Online', viewValue: 'Online' },
    { value: 'Offline', viewValue: 'Offline' },
    { value: 'Both', viewValue: 'Both' }
  ];
  categories = [
    {
      name: 'Retail & E-commerce',
      subCategories: [
        'RE001: Apparel & Clothing', 'RE002: Electronics & Gadgets', 'RE003: Home Decor & Furniture', 'RE004: Beauty & Personal Care', 'RE005: Books & Stationery', 'RE006: Sports & Fitness Equipment', 'RE007: Grocery & Food Items'
      ]
    },
    {
      name: 'Food & Beverage',
      subCategories: [
        'FB001: Cafe',
        'FB002: Restaurant', 'FB003: Bar & Lounge', 'FB004: Fast Food Outlet', 'FB005: Bakery & Confectionery', 'FB006: Catering Services'
      ]
    },
    {
      name: 'Health & Wellness',
      subCategories: [
        'HW001: Gym & Fitness Center', 'HW002: Spa & Salon', 'HW003: Medical Clinic', 'HW004: Pharmacy', 'HW005: Health Supplement Store', 'HW006: Mental Health Services'
      ]
    },
    {
      name: 'Professional Services',
      subCategories: [
        'PS001: Legal Services', 'PS002: Accounting & Financial Services', 'PS003: Marketing & Advertising Agency', 'PS004: IT & Software Development', 'PS005: Consultancy Services', 'PS006: Real Estate Agency'
      ]
    },
    {
      name: 'Education & Training',
      subCategories: [
        'ET001: School', 'ET002: College/University', 'ET003: Online Education Platform', 'ET004: Coaching Center', 'ET005: Vocational Training'
      ]
    },
    {
      name: 'Entertainment & Media',
      subCategories: [
        'EM001: Movie Theater', 'EM002: Event Management', 'EM003: Music & Dance Studio', 'EM004: Media & Broadcasting', 'EM005: Photography & Videography'
      ]
    },
    {
      name: 'Travel & Hospitality',
      subCategories: [
        'TH001: Hotel & Resorts', 'TH002: Travel Agency', 'TH003: Tour Operators', 'TH004: Car Rentals', 'TH005: Adventure Sports & Outdoor Activities'
      ]
    },
    {
      name: 'Manufacturing & Industry',
      subCategories: [
        'MI001: Automotive Manufacturing', 'MI002: Textile & Garment Manufacturing', 'MI003: Food & Beverage Production', 'MI004: Electronics & Appliance Manufacturing', 'MI005: Construction Materials'
      ]
    },
    {
      name: 'Finance & Insurance',
      subCategories: [
        'FI001: Banking', 'FI002: Insurance Services', 'FI003: Investment Firms', 'FI004: Financial Advisory'
      ]
    },
    {
      name: 'Technology & Innovation',
      subCategories: [
        'TI001: Software Development', 'TI002: Hardware Development', 'TI003: AI & Machine Learning', 'TI004: Blockchain & Cryptocurrency', 'TI005: Internet of Things (IoT)'
      ]
    },
    {
      name: 'Arts & Crafts',
      subCategories: [
        'AC001: Art Gallery', 'AC002: Craft Supplies Store', 'AC003: Handmade Goods Store', 'AC004: Pottery Studio'
      ]
    }, {
      name: 'Automotive',
      subCategories: ['AT001: Car Dealership', 'AT002: Auto Repair Shop', 'AT003: Car Wash Services', 'AT004: Auto Parts Store']
    }, {
      name: 'Home Services',
      subCategories: ['HS001: Plumbing Services', 'HS002: Electrical Services', 'HS003: Home Cleaning', 'HS004: Landscaping & Gardening']
    }, {
      name: 'Fashion & Lifestyle',
      subCategories: ['FL001: Fashion Boutique', 'FL002: Jewelry Store', 'FL003: Lifestyle Blog', 'FL004: Interior Design Services']
    }, {
      name: 'Pet Care',
      subCategories: ['PC001: Pet Store', 'PC002: Veterinary Clinic', 'PC003: Pet Grooming Services', 'PC004: Pet Training Services']
    }, {
      name: 'Logistics & Transportation',
      subCategories: ['LT001: Courier Services', 'LT002: Freight Forwarding', 'LT003: Transportation Services', 'LT004: Warehousing & Storage']
    }, {
      name: 'Energy & Utilities',
      subCategories: ['EU001: Renewable Energy', 'EU002: Oil & Gas', 'EU003: Water Supply & Treatment', 'EU004: Electric Power Generation']
    }, {
      name: 'Government & Public Sector',
      subCategories: ['GP001: Municipal Services', 'GP002: Healthcare Services', 'GP003: Education & Training', 'GP004: Public Safety & Law Enforcement']
    },
    {
      name: 'Miscellaneous',
      subCategories: ['MS001: Event Planning', 'MS002: Freelance Services', 'MS003: Online Marketplace', 'MS004: Subscription Boxes']
    }
  ];

  selectedCategory: string = '';
  subCategories: string[] = [];
  Type: string = '';

  daysOfWeek = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
  selections = Array(7).fill('');

  validateSelections() {
    const postCount = this.selections.filter(sel => sel === '1 Post').length;
    const reelCount = this.selections.filter(sel => sel === '1 Reel').length;
    const carouselCount = this.selections.filter(sel => sel === '1 Carousel').length;

    if (postCount > 5 || reelCount > 1 || carouselCount > 1) {
      this.errorMessage = 'Total should be 5 Posts, 1 Reel, and 1 Carousel only.';
    } else {
      this.errorMessage = '';
    }
  }
  constructor(
    public service: SharkifyAiSerivceService, public router: Router,
    public app: AppComponent, public route: ActivatedRoute
  ) { }


  ngOnInit(): void {
    // Set initial form values (default posting schedule)
    this.RegularPostingSchedule_Mon.setValue('Post');
    this.RegularPostingSchedule_Tue.setValue('Post');
    this.RegularPostingSchedule_Wed.setValue('Post');
    this.RegularPostingSchedule_Thu.setValue('Post');
    this.RegularPostingSchedule_Fri.setValue('Post');
    this.RegularPostingSchedule_Sat.setValue('Reel');
    this.RegularPostingSchedule_Sun.setValue('Carousel');

    // Fetch UserId from local storage
    this.UserId = localStorage.getItem('UserId');

    // Fetch the BusinessInfo data from the service
    this.BusinessInfos = this.service.getBusinessInfo();
    // this.BusinessInfos = localStorage.getItem("BusinessInfos");
    const storedBusinessInfos = localStorage.getItem("EditBusinessInfos");
if (storedBusinessInfos) {
  this.EditBusinessInfos = JSON.parse(storedBusinessInfos);
} else {
  console.error("No BusinessInfos found in localStorage.");
}
    this.setdata();
  }
  async setdata() {
    if (this.BusinessInfos) {
      // Populate the form fields with the retrieved data

      // this.BusinessInfoId.setValue(this.BusinessInfos.BusinessInfoId);
      this.BusinessInfoId = this.BusinessInfos.BusinessInfoId;
      this.BusinessInfo_BusinessName.setValue(this.BusinessInfos.BusinessInfo_BusinessName);
      this.BusinessInfo_BusinessCategory.setValue(this.BusinessInfos.BusinessInfo_BusinessCategory);
      this.BusinessInfo_BusinessCode.setValue(this.BusinessInfos.BusinessInfo_BusinessCode);
      this.BusinessInfo_BusinessType.setValue(this.BusinessInfos.BusinessInfo_BusinessType);
      this.BusinessInfo_WebsiteURL.setValue(this.BusinessInfos.BusinessInfo_WebsiteURL);
      this.CurrentOnlinePresence_DoYouCurrentlySellOnline.setValue(this.BusinessInfos.CurrentOnlinePresence_DoYouCurrentlySellOnline);
      this.CurrentOnlinePresence_InstagramFollowers.setValue(this.BusinessInfos.CurrentOnlinePresence_InstagramFollowers);
      this.CurrentOnlinePresence_InstagramUsername.setValue(this.BusinessInfos.CurrentOnlinePresence_InstagramUsername);
      this.CurrentOnlinePresence_LinkedInUsername.setValue(this.BusinessInfos.CurrentOnlinePresence_LinkedInUsername);
      this.ContentRequirements_IntrestedContent.setValue(this.BusinessInfos.ContentRequirements_IntrestedContent.split(','));
      this.ContentRequirements_SpecificThemes.setValue(this.BusinessInfos.ContentRequirements_SpecificThemes);
      this.ContentRequirements_Description.setValue(this.BusinessInfos.ContentRequirements_Description);
      this.TargetAudience_FromAge.setValue(this.BusinessInfos.TargetAudience_FromAge);
      this.TargetAudience_ToAge.setValue(this.BusinessInfos.TargetAudience_ToAge);
      this.TargetAudience_Gender.setValue(this.BusinessInfos.TargetAudience_Gender);
      this.TargetAudience_Interests.setValue(this.BusinessInfos.TargetAudience_Interests);
      this.tags = this.BusinessInfos.TargetAudience_SpecificLocations.split(',');
      this.TargetAudience_SpecificLocations = this.getCombinedTags();
      this.ContentGoals_PrimaryGoals.setValue(this.BusinessInfos.ContentGoals_PrimaryGoals.split(','));
      this.ContentGoals_KeyMessages.setValue(this.BusinessInfos.ContentGoals_KeyMessages);
      this.RegularPostingSchedule_Customize.setValue(this.BusinessInfos.RegularPostingSchedule_Customize);
      this.RegularPostingSchedule_Mon.setValue(this.BusinessInfos.RegularPostingSchedule_Mon);
      this.RegularPostingSchedule_Tue.setValue(this.BusinessInfos.RegularPostingSchedule_Tue);
      this.RegularPostingSchedule_Wed.setValue(this.BusinessInfos.RegularPostingSchedule_Wed);
      this.RegularPostingSchedule_Thu.setValue(this.BusinessInfos.RegularPostingSchedule_Thu);
      this.RegularPostingSchedule_Fri.setValue(this.BusinessInfos.RegularPostingSchedule_Fri);
      this.RegularPostingSchedule_Sat.setValue(this.BusinessInfos.RegularPostingSchedule_Sat);
      this.RegularPostingSchedule_Sun.setValue(this.BusinessInfos.RegularPostingSchedule_Sun);
      this.BusinessSpecificUploads_Services.setValue(this.BusinessInfos.BusinessSpecificUploads_Services);
      this.CompetitorInformation_Details.setValue(this.BusinessInfos.CompetitorInformation_Details);
      this.AdditionalDetails_Details.setValue(this.BusinessInfos.AdditionalDetails_Details);
      // this.ContentRequirements_SampleImages = this.BusinessInfos.ContentRequirements_SampleImages;
      // this.Content_Requirements_Sample_Images[0] = this.ContentRequirements_SampleImages;

      this.ContentRequirements_SampleImages = this.BusinessInfos.ContentRequirements_SampleImages.split(', ');
      if (this.ContentRequirements_SampleImages.length > 0) {
        for (let i = 0; i < this.ContentRequirements_SampleImages.length; i++) {
          this.Content_Requirements_Sample_Images.push(this.ContentRequirements_SampleImages[i]);
        }
      }
      else {
        this.Content_Requirements_Sample_Images[0] = this.ContentRequirements_SampleImages[0];
      }
      this.BusinessSpecificUploads_Images = this.BusinessInfos.BusinessSpecificUploads_Images.split(', ');
      if (this.BusinessSpecificUploads_Images.length > 0) {
        for (let i = 0; i < this.BusinessSpecificUploads_Images.length; i++) {
          this.Business_Specific_Uploads_Images[i] = this.BusinessSpecificUploads_Images[i];
        }
      }
      else {
        this.Business_Specific_Uploads_Images[0] = this.BusinessSpecificUploads_Images[0];
      }
      // this.TargetAudience_SpecificLocations.setValue(this.BusinessInfos.TargetAudience_SpecificLocations.split(','));
      
    } else {
      console.error('No business info found in the service');
    }
  }
  getSafeValue(value: string | null): string {
    return value === null || value === 'undefined' ? '' : value;
  }
  handleKeyDown(event: KeyboardEvent): void {
    if ((event.key === 'Enter' || event.key === ',') && this.inputValue.trim() !== '') {
      event.preventDefault(); // Prevent creating a new line
      this.addTag(this.inputValue.trim());
      this.inputValue = '';
    }
  }

  // Add a tag to the tags array
  addTag(tag: string): void {
    if (this.tags.indexOf(tag) === -1) {
      this.tags.push(tag);
      this.TargetAudience_SpecificLocations = this.getCombinedTags(); // Assign combined tags
    }
  }
  getCombinedTags(): string {
    return this.tags.join(', ');
  }

  // Remove tag when the close button is clicked
  removeTag(tag: string): void {
    this.tags = this.tags.filter(t => t !== tag);
  }
  onCategoryChange(categoryName: string): void {
    const selectedCategory = this.categories.find(category => category.name === categoryName);
    this.subCategories = selectedCategory ? selectedCategory.subCategories : [];
  }
  onUpdate() {
    if (
      this.BusinessInfo_BusinessName.valid &&
      this.BusinessInfo_BusinessCategory.valid &&
      this.BusinessInfo_BusinessCode.valid &&
      this.BusinessInfo_BusinessType.valid &&
      this.CurrentOnlinePresence_DoYouCurrentlySellOnline.valid &&
      this.ContentRequirements_IntrestedContent.valid &&
      this.ContentRequirements_SpecificThemes.valid &&
      this.TargetAudience_FromAge.valid &&
      this.TargetAudience_ToAge.valid &&
      this.TargetAudience_Gender.valid &&
      this.TargetAudience_Interests.valid &&
      this.RegularPostingSchedule_Customize.valid &&
      this.BusinessSpecificUploads_Services.valid &&
      this.ContentGoals_PrimaryGoals.valid) {
      this.service.UpdateBusinessInfo(
        this.UserId, this.BusinessInfoId,
        this.BusinessInfo_BusinessName.value + "",
        this.BusinessInfo_BusinessCategory.value + "",
        this.BusinessInfo_BusinessCode.value + "",
        this.BusinessInfo_BusinessType.value + "",
        this.BusinessInfo_WebsiteURL.value + "",
        this.CurrentOnlinePresence_DoYouCurrentlySellOnline.value + "",
        this.CurrentOnlinePresence_InstagramFollowers.value + "",
        this.CurrentOnlinePresence_InstagramUsername.value + "",
        this.CurrentOnlinePresence_LinkedInUsername.value + "",
        this.ContentRequirements_IntrestedContent.value + "",
        this.ContentRequirements_SpecificThemes.value + "",
        this.ContentRequirements_Description.value + "",
        this.ContentRequirements_SampleImages.join(', ') + "",
        this.TargetAudience_FromAge.value + "",
        this.TargetAudience_ToAge.value + "",
        this.TargetAudience_Gender.value + "",
        this.TargetAudience_Interests.value + "",
        this.TargetAudience_SpecificLocations + "",
        this.ContentGoals_PrimaryGoals.value + "",
        this.ContentGoals_KeyMessages.value + "",
        this.RegularPostingSchedule_Customize.value + "",
        this.RegularPostingSchedule_Mon.value + "",
        this.RegularPostingSchedule_Tue.value + "",
        this.RegularPostingSchedule_Wed.value + "",
        this.RegularPostingSchedule_Thu.value + "",
        this.RegularPostingSchedule_Fri.value + "",
        this.RegularPostingSchedule_Sat.value + "",
        this.RegularPostingSchedule_Sun.value + "",
        this.BusinessSpecificUploads_Images.join(', ') + "",
        this.BusinessSpecificUploads_Services.value + "",
        this.CompetitorInformation_Details.value + "",
        this.AdditionalDetails_Details.value + ""
      ).subscribe(data => {
        // localStorage.setItem('BusinessInfo_BusinessName', this.BusinessInfo_BusinessName.value + '');
        if (data.Code == 200) {
          this.app.displayLoader(false);
        } else {
          alert("update failure");
          // localStorage.setItem('BusinessInfo_BusinessName', this.BusinessInfo_BusinessName.value + '');
          this.app.displayLoader(false);
        }
      });
    } else {
      this.app.displayLoader(false);
      alert("not working");
    }
  }

}